import React from "react";

import { useNavigate } from "react-router-dom";
import { StartConversation } from "../Casinoengine/StartConversation";
import Compliance from "../../images/casinoengine/CE-Compliance.webp";
import { Logos } from "./Logos";

const CasinoCompliance = () => {
  const navigate = useNavigate();
  const integrationData = {
  title:
    "Regulated Casino Integration for License Compliance",
  description:
    "CasinoEngine is designed to address the complex challenges faced by casino operators when working with multiple content providers across different jurisdictions. Our platform is easily adaptable to support new regulatory requirements while seamlessly meeting existing demands, including:",
    listItems: [
      "Reality checks",
      "Time limit calculations",
      "Wagering limits across all vendors",
      "Authenticity checks",
    ],
    image: {
      src: Compliance,
      alt: "Compliant casino integration to handle specific licence requirements",
    },
  };
  const { title, description, listItems, image } = integrationData;
  return (
    <>
      <main className="overflow-hidden">
        <section className="simple-intro">
          <div className="container container_custom">
            <div className="row align-items-center justify-content-between">
              <div className="col-xl-5 col-lg-6">
                <h1 className="section-title heading_left">
                Regulated Casino Across Multiple Jurisdictions
                </h1>
                <div className="description">
                  <p>
                    CasinoEngine is fully certified across multiple
                    jurisdictions, and we are committed to continuously adapting
                    our casino software platform to meet evolving regulatory
                    requirements.
                  </p>
                </div>
                <div className="btns pt-5">
                  <a href="/connect" className="btn btn_blue">
                    Contact us
                  </a>
                </div>
              </div>
              <div className="col-md-6">
                <img
                  src="https://everymatrix.com/wp-content/uploads/2019/06/CE-Compliance-img1.png"
                  className="illustration"
                />
              </div>
            </div>
          </div>
          <a href="#explore" className="explore"></a>
        </section>

        <Logos />

        <section className="integration box-full sec-padd">
          <div className="container">
            <div className="row">
              <div className="col box">
                <div className="inner">
                  <div className="inner-content">
                    <div className="row justify-content-between align-items-center">
                      <div className="col-lg-5">
                        <h3 className="section-title  heading_left">{title}</h3>
                        <div className="description">
                          <p>{description}</p>
                          <ul>
                            {listItems.map((item, idx) => (
                              <li key={idx}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <img
                          src={image.src}
                          alt={image.alt}
                          className="img-fluid mx-auto"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <StartConversation />
      </main>
    </>
  );
};

export default CasinoCompliance;
